// Lucide-style 1.5px-stroke SVG icons. Kept inline so we don't ship a whole
// icon library for the handful we actually use. All take an optional className
// + style so callers can size them.

import { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  style?: CSSProperties;
  size?: number;
  title?: string;
}

function svgProps({ className, style, size, title }: IconProps) {
  return {
    className,
    style: { width: size ?? 16, height: size ?? 16, ...(style || {}) },
    viewBox: '0 0 24 24',
    fill: 'none' as const,
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': title ? undefined : true,
    role: title ? 'img' : undefined,
  };
}

export const IconFolder: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
  </svg>
);

export const IconInbox: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
    <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
  </svg>
);

export const IconTemplate: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <rect x="3" y="3" width="18" height="18" rx="1" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="9" y1="9" x2="9" y2="21" />
  </svg>
);

export const IconArchive: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <polyline points="21 8 21 21 3 21 3 8" />
    <rect x="1" y="3" width="22" height="5" />
    <line x1="10" y1="12" x2="14" y2="12" />
  </svg>
);

export const IconCheckCircle: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export const IconPlus: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconClose: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const IconChevDown: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const IconChev: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const IconFilter: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);

export const IconComment: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    {p.title ? <title>{p.title}</title> : null}
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
